<template>
  <div class="scenes-boxes">
    <Scene
      v-for="scene in scenes"
      :key="scene.id"
      :scene-id="scene.id"
      :scene-name="scene.name"
      :image-url="scene.imageUrl"
      :link-url="scene.linkUrl"
      :width="width"
    />
  </div>
</template>
<script>
import Scene from './Scene.vue'
export default {
  components: { Scene },
  props: {
    scenes: {
      type: Array,
      required: true
    },
    width: {
      type: String,
      required: false,
      default: '160px'
    }
  }
}
</script>
